export enum ManagedWarehouseTypes {
    BIGQUERY = 'BIGQUERY'
}
